import React, { SVGAttributes } from 'react'

export const DiamondFill: React.FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.74806 13.7481L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858L18.2519 13.7481C19.1025 12.8975 19.5277 12.4723 19.6583 11.9193C19.7888 11.3664 19.5986 10.7958 19.2182 9.65473L18.9117 8.73509C18.4717 7.41505 18.2517 6.75503 17.7279 6.37752C17.2041 6 16.5084 6 15.117 6H8.88304C7.49159 6 6.79587 6 6.2721 6.37752C5.74832 6.75503 5.52832 7.41505 5.0883 8.73509L4.78176 9.65473C4.40139 10.7958 4.21121 11.3664 4.34175 11.9193C4.47228 12.4723 4.89754 12.8975 5.74806 13.7481Z"
    />
  </svg>
)
